import { render } from "./multi-column.vue?vue&type=template&id=06f1cb18"
import script from "./multi-column.vue?vue&type=script&lang=js"
export * from "./multi-column.vue?vue&type=script&lang=js"

import "./multi-column.vue?vue&type=style&index=0&id=06f1cb18&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__